<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="contract" :translate-params="{id: contract.id, name: contract.name}">Edit Contract
        #%{id} - %{name}
      </translate>
    </h1>
    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton variant="outline" color="success" @click="onReset" ref="reset-button" v-translate
                   translate-context="form" class="mr-2">Reset
          </CButton>
          <CButton color="primary" @click="onSave" ref="save-button">Save</CButton>
        </div>
      </CCardHeader>
      <CCardBody class="p-0">
        <CContainer fluid class="grid-stripped">
          <PFRow :label="$pgettext('contract_manager.label', 'Qty')">
            <CInput v-model="form.qty" type="number"/>
          </PFRow>
          <template v-if="!form.is_saas">
            <PFRow :label="$pgettext('contract.create.label','Template')" size="12x12">
              <PSelectKeyValue :options="searchTemplate" :value.sync="form.template" placeholder="Select Template"/>
            </PFRow>
            <PFRow :label="$pgettext('contract.create.label','Vertical')" size="12x12">
              <PSelectKeyValue :options="searchVertical" :value.sync="form.vertical" placeholder="Select Vertical"/>
            </PFRow>
            <PFRow :label="$pgettext('contract.create.label','Terzo Dominio ( ex Event Owner )')" size="12x12">
              <PSelectKeyValue :options="searchEventOwner" :value.sync="form.event_owner"
                               placeholder="Select Event owner"/>
            </PFRow>
          </template>
          <PFRow :label="$pgettext('contract_manager.label', 'Name')">
            <CInput v-model="form.name"/>
          </PFRow>
          <PFRow :label="$pgettext('contract_manager.label', 'Currency')">
            <CurrencySelect :value="form.currency" @input="form.currency = $event"/>
          </PFRow>
          <template v-if="form.is_saas">
            <PFRow :label="$pgettext('contract_manager.label', 'Plan Category')" size="12x12">
              <PSelectKeyValue :options="planCategoryOptions" :value.sync="form.plan_category" placeholder="Select Plan Category" @input="onPlanCategoryChange"/>
            </PFRow>
            <PFRow :label="$pgettext('contract_manager.label', 'Base Plan')" size="12x12">
              <PSelectKeyValue :options="basePlanOptions" :value.sync="form.base_plan" placeholder="Select Base Plan" :disabled="!form.plan_category"/>
            </PFRow>
            <PFRow :label="$pgettext('contract_manager.label', 'Is Subscription')">
              <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_subscription"/>
            </PFRow>
            <template v-if="form.is_subscription && form.settings">
              <PFRow :label="$pgettext('contract_manager.label', 'Num Photo Included')">
                <CInput v-model="form.settings.num_photo_included" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Num Max Photo')">
                <CInput v-model="form.settings.num_max_photo" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Is Promo')">
                <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.settings.is_promo"/>
              </PFRow>
            </template>
          </template>
          <template v-if="!form.is_saas">
            <template v-if="!form.is_subscription && form.plan">
              <PFRow :label="$pgettext('contract_manager.label', 'Num Photo Included')">
                <CInput v-model="form.plan.num_photo_included" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Num Max Photo')">
                <CInput v-model="form.plan.num_max_photo" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Max Participants')">
                <CInput v-model="form.plan.max_participants" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Extra Photo Price')">
                <CInput v-model="form.plan.extra_photo_price" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Is Promo')">
                <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.plan.is_promo"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Is Ecommerce')">
                <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.plan.is_ecommerce"/>
              </PFRow>
              <template v-if="form.plan.is_ecommerce">
                <PFRow :label="$pgettext('contract_manager.label', 'Pica fee perc')"
                       :helpText="$pgettext('contract.help', 'Leave 0 to use the Contract Manager default value')">
                  <CInput v-model="form.plan.pica_fee_perc" type="number"/>
                </PFRow>
              </template>
            </template>
            <template v-else-if="form.is_subscription && form.settings">
              <PFRow :label="$pgettext('contract_manager.label', 'Num Photo Included')">
                <CInput v-model="form.settings.num_photo_included" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Num Max Photo')">
                <CInput v-model="form.settings.num_max_photo" type="number"/>
              </PFRow>
              <PFRow :label="$pgettext('contract_manager.label', 'Is Promo')">
                <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.settings.is_promo"/>
              </PFRow>
            </template>
          </template>
        </CContainer>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import PFRow from "@/domain/core/components/PFRow.vue";
import PSelectKeyValue from "@/domain/core/components/PSelectKeyValue.vue";
import CurrencySelect from "@/domain/core/components/CurrencySelect.vue";

export default {
  name: 'EditContract',
  components: {PSelectKeyValue, PFRow, CurrencySelect},
  data() {
    return {
      loading: true,
      form: {
        qty: null,
        template: '',
        vertical: '',
        event_owner: '',
        name: '',
        currency: null,
        is_subscription: false,
        is_saas: false,
        plan_category: null,
        base_plan: null,
        plan: {
          num_photo_included: null,
          num_max_photo: null,
          max_participants: null,
          extra_photo_price: null,
          is_promo: false,
          is_ecommerce: false,
          pica_fee_perc: 0,
        },
        settings: {
          num_photo_included: null,
          num_max_photo: null,
          is_promo: null,
        },
      },
    }
  },
  async mounted() {
    try {
      // Load contract manager first for breadcrumb and config
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.contract_manager}),
        this.fetchContractManager(this.$route.params.contract_manager)
      ])

      await this.fetchContract({
        id: this.$route.params.id,
        contract_manager: this.$route.params.contract_manager
      })
      this.onReset()

      // Load plan categories for SaaS contracts
      if (this.contract.is_saas) {
        await this.searchPlanCategory()
        // Load base plans if category is already selected
        if (this.contract.plan_category) {
          await this.searchBasePlan(this.contract.plan_category)
        }
      }
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.detail', params: {id: this.$route.params.contract_manager}})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
      'contract',
      'plan_categories',
      'base_plans',
    ]),
    planCategoryOptions() {
      return this.plan_categories || []
    },
    basePlanOptions() {
      return this.base_plans || []
    }
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
      'fetchContract',
      'updateContract',
      'searchEventOwner',
      'searchTemplate',
      'searchVertical',
      'searchPlanCategory',
      'searchBasePlan',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async onSave() {
      await this.updateContract({
        contract_manager: this.$route.params.contract_manager,
        id: this.contract.id,
        data: this.form,
      })
      await this.$router.push({name: 'contract_manager.detail', params: {id: this.$route.params.contract_manager}})
      throw new SuccessNotification(this.$pgettext('contract', 'Contract updated!'))
    },
    async onPlanCategoryChange(categoryId) {
      this.form.base_plan = null // Reset base plan when category changes
      if (categoryId) {
        await this.searchBasePlan(categoryId)
      }
    },
    onReset() {
      this.form = {...this.contract}
      // Add plan/settings defaults based on contract type
      if (this.form.is_saas) {
        // For SaaS contracts, only add settings if it's a subscription
        if (this.form.is_subscription) {
          this.form.settings = this.contract.settings || {
            num_photo_included: null,
            num_max_photo: null,
            is_promo: null,
          }
        }
      } else {
        // For non-SaaS contracts, add plan defaults
        this.form.plan = this.contract.plan || {
          num_photo_included: null,
          num_max_photo: null,
          max_participants: null,
          extra_photo_price: null,
          is_promo: false,
          is_ecommerce: false,
          pica_fee_perc: 0,
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
